import { call, put } from 'redux-saga/effects';
import Http from '../../../../../libs/Http';

export function* fetchSellPayments(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  const result = yield call(Http.get, '/payments/list', {
    query: {
      page: -1,

      filters: JSON.stringify({
        status: 'verified',
        ...payload.filters,
      }),
      sort: payload.filters.sort,
    }
  });

  yield put({
    type: 'SET_SELL_PAYMENTS',
    payload: {
      payments: result.payments,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* fetchSellChannels(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  const result = yield call(Http.get, '/channels/soldInTrade', {
    query: {
      tradeId: payload.tradeId,
    }
  });

  yield put({
    $global: true,
    type: 'SET_SELL_CHANNELS',
    payload: {
      channels: result.channels,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* sendSellPayment(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  const result = yield call(Http.post, '/payments/sendSellPayment', {
    body: {
      tradeId: payload.tradeId,
      paymentId: payload.paymentId,
    },
  });

  // TODO: refetch sell payments and sell channels
  yield put({
    type: 'FETCH_SELL_CHANNELS',
    payload: {
      tradeId: payload.tradeId,
    }
  });
  yield put({
    type: 'FETCH_SELL_PAYMENTS',
    payload: {
      filters: payload.filters,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* setSellChannelAsFraud(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  yield call(Http.post, '/channels/update', {
    body: {
      _id: payload.data._id,
      data: {
        ...payload.data,
        status: 'fraud',
      },
    }
  });

  // TODO: refetch sell payments and sell channels
  yield put({
    type: 'FETCH_SELL_CHANNELS',
    payload: {
      tradeId: payload.tradeId,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* setSellPaymentAsFraud(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  yield call(Http.post, '/payments/setAsFraud', {
    body: {
      _id: payload.payment._id,
    }
  });

  // TODO: refetch sell payments and sell channels
  yield put({
    type: 'FETCH_SELL_PAYMENTS',
    payload: {
      filters: payload.filters,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}


export default function* ({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_SELL_PAYMENTS', fetchSellPayments),
    takeLatest('FETCH_SELL_CHANNELS', fetchSellChannels),
    takeLatest('SEND_SELL_PAYMENT', sendSellPayment),
    takeLatest('SET_SELL_CHANNEL_AS_FRAUD', setSellChannelAsFraud),
    takeLatest('SET_SELL_PAYMENT_AS_FRAUD', setSellPaymentAsFraud),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsPanel.sagas.js